import createIcon from '../../createIcon';

/**
 * @component @name NearMeDisabled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuMjg5NiA3LjA0OTYxTDIwLjI4OTYgMy43MDk2MUwxNi45NDk2IDEyLjcwOTZMMTEuMjg5NiA3LjA0OTYxWk0yMS44OTk2IDIwLjQ4OTZMMy41MDk2MSAyLjA5OTYxTDIuMDk5NjEgMy41MTk2MUw3LjE2OTYxIDguNTg5NjFMMi4yODk2MSAxMC4zOTk2VjExLjgwOTZMOS4zNTk2MSAxNC42Mzk2TDEyLjE4OTYgMjEuNzA5NkgxMy41OTk2TDE1LjQwOTYgMTYuODI5NkwyMC40Nzk2IDIxLjg5OTZMMjEuODk5NiAyMC40ODk2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NearMeDisabled = createIcon('NearMeDisabled', [
  [
    'path',
    {
      d: 'M11.2896 7.04961L20.2896 3.70961L16.9496 12.7096L11.2896 7.04961ZM21.8996 20.4896L3.50961 2.09961L2.09961 3.51961L7.16961 8.58961L2.28961 10.3996V11.8096L9.35961 14.6396L12.1896 21.7096H13.5996L15.4096 16.8296L20.4796 21.8996L21.8996 20.4896Z',
      key: 'jwz8c7',
    },
  ],
]);

export default NearMeDisabled;
